import React, { useEffect, useRef } from 'react'
import Plot from 'plotly.js-dist-min'
//test
const ScatterPlot = ({ data }) => {
  const plotDiv = useRef(null)

  useEffect(() => {
    const categories = [...new Set(data.map((item) => item.Category))]
    const plotData = categories.map((category) => {
      const filteredData = data.filter((item) => item.Category === category)
      return {
        type: 'scatter',
        mode: 'markers',
        text: filteredData.map((item) => item.label),
        hoverinfo: 'text',
        x: filteredData.map((item) => item.x),
        y: filteredData.map((item) => item.y),
        marker: { size: 12 },
        name: category // Use category name as the trace name
      }
    })

    Plot.newPlot(plotDiv.current, plotData, {
      title: 'AI defined categories',
      xaxis: { title: 'X Axis' },
      yaxis: { title: 'Y Axis' }
    })
  }, [data])

  return <div ref={plotDiv}></div>
}

export default ScatterPlot
